import { Base } from '@studiometa/js-toolkit';
import MenuItem from '#js/molecules/MenuItem.js';

/**
 * Homepage class.
 */
export default class Header extends Base {
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'Header',
    components: { MenuItem },
    refs: ['burger[]'],
  };

  /**
   * Mount Header Component
   * @returns {void}
   */
  mounted() {
    this.body = document.querySelector('body');
  }

  /**
   * Click on burger to open menu
   * @returns {void}
   */
  onBurgerClick() {
    this.body.classList.toggle('menu-is-open');
  }

  /**
   * Close all opened submenu
   * @returns {void}
   */
  onMenuItemOpenSubmenu() {
    this.$children.MenuItem.forEach((element) => {
      element.closeSubmenu();
    });
  }
}
